/* src/app/features/leilao/consulta-status-leilao/consulta-status-leilao-listagem/consulta-status-leilao-listagem.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=consulta-status-leilao-listagem.component.css.map */
